"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rotateImage = void 0;
const Exif = require("piexifjs");
const getCanvasBlob_1 = require("./getCanvasBlob");
const getImage_1 = require("./getImage");
const transformCanvas = (imageMeta, canvas, image) => {
    const orientation = imageMeta["0th"]["274"];
    const { width: imageWidth, height: imageHeight } = image;
    /**
     * 5, 6, 7, and 8, are all portrait, therefore swap the width and heights to normalise.
     * @see https://sirv.com/help/resources/rotate-photos-to-be-upright/
     */
    if (4 < orientation && orientation < 9) {
        canvas.width = imageHeight;
        canvas.height = imageWidth;
    }
    else {
        canvas.width = imageWidth;
        canvas.height = imageHeight;
    }
    const ctx = canvas.getContext("2d");
    switch (orientation) {
        case 2:
            ctx.transform(-1, 0, 0, 1, imageWidth, 0);
            break;
        case 3:
            ctx.transform(-1, 0, 0, -1, imageWidth, imageHeight);
            break;
        case 4:
            ctx.transform(1, 0, 0, -1, 0, imageHeight);
            break;
        case 5:
            ctx.transform(0, 1, 1, 0, 0, 0);
            break;
        case 6:
            ctx.transform(0, 1, -1, 0, imageHeight, 0);
            break;
        case 7:
            ctx.transform(0, -1, -1, 0, imageHeight, imageWidth);
            break;
        case 8:
            ctx.transform(0, -1, 1, 0, 0, imageWidth);
            break;
        default:
            break;
    }
};
/**
 * Given a data url for a jpeg image, this will rotate it to be upwards, and then reset the orientation exif flag.
 * When the given data url is not for a jpeg image or is not of valid exif data, skip rotating and return the image in a format based on the return type.
 */
const rotateImage = async (imageUrl, returnType) => {
    const canvas = document.createElement("canvas");
    // get an image element, we use this for width/height and drawing to the canvas.
    const imageTag = await (0, getImage_1.getImageTag)(imageUrl);
    // attempt to get the raw meta and exif data.
    let imageMeta, newImage;
    try {
        // when the image is jpeg with valid exif data
        imageMeta = Exif.load(imageUrl);
    }
    catch (e) {
        // when the image is not jpeg or not with valid exif data
        imageMeta = null;
    }
    // if exif data is available
    if (imageMeta) {
        // normalize the canvas regardless of orientation.
        transformCanvas(imageMeta, canvas, imageTag);
        // draw image to canvas.
        canvas.getContext("2d").drawImage(imageTag, 0, 0);
        // set orientation to 1 so no software attempts to rotate.
        imageMeta["0th"][Exif.ImageIFD.Orientation] = 1;
        newImage = Exif.insert(Exif.dump(imageMeta), canvas.toDataURL("image/jpeg"));
    }
    else {
        // transform canvas
        canvas.width = imageTag.width;
        canvas.height = imageTag.height;
        const ctx = canvas.getContext("2d");
        // use white fill style for transparent png
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        // draw image to canvas
        canvas.getContext("2d").drawImage(imageTag, 0, 0);
        newImage = canvas.toDataURL("image/jpeg");
    }
    return returnType === "blob" ? await (0, getCanvasBlob_1.getCanvasBlob)(canvas) : newImage;
};
exports.rotateImage = rotateImage;
//# sourceMappingURL=rotateImage.js.map